import { Typography } from "@appsflyer/fe-ui-core";
import AmplitudeLink from "../../services/AmplitudeLink";
import {
  DJCodeBlock,
  DJSimpleCodeBlock,
  ICodeBlock,
} from "../../main/components/codeblock";
import { getCodeSnippet } from "../codeTemplateUtils";
import { SendInappStep } from "./types";

interface AndroidStepsParams {
  t: (key: string) => string;
  lang?: string;
  codeProps: ICodeBlock;
  codeProps2: ICodeBlock;
}

interface IOStepsParams {
  t: (key: string) => string;
  lang?: string;
}

interface FlutterStepsParams {
  t: (key: string) => string;
}

interface ReactNativeStepsParams {
  t: (key: string) => string;
}

export const createAndroidSteps = ({
  t,
  codeProps,
  codeProps2,
}: AndroidStepsParams): SendInappStep[] => [
  {
    label: t("ip_AppEvents_android_stepOneHeading"),
    component: (
      <>
        <Typography>
          {t("ip_AppEvents_android_stepOneDescription")}
          <AmplitudeLink
            href="https://dev.appsflyer.com/hc/docs/android-sdk-reference-appsflyerlib"
            target="_blank"
            rel="noopener noreferrer"
          >
            <code>{t("ip_AppEvents_android_appsFlyerLibLink")}</code>
          </AmplitudeLink>
        </Typography>
        <DJCodeBlock {...codeProps} />
      </>
    ),
    shouldDisplayNavigationButtons: true,
  },
  {
    label: t("ip_AppEvents_android_stepTwoHeading"),
    component: (
      <>
        <Typography>{t("ip_AppEvents_android_stepTwoDescription")}</Typography>
        <DJCodeBlock {...codeProps2} />
      </>
    ),
    shouldDisplayNavigationButtons: true,
  },
];

export const createIOSteps = ({ t }: IOStepsParams): SendInappStep[] => [
  {
    label: t("ip_SendInApp_ios_importAppsFlyerLib"),
    component: (
      <>
        <Typography>
          {t("ip_SendInApp_ios_stepOneDescription")}
          <AmplitudeLink
            href="https://dev.appsflyer.com/hc/docs/ios-sdk-reference-appsflyerlib"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("ip_SendInApp_ios_linkText")}
          </AmplitudeLink>
        </Typography>
        <DJCodeBlock
          codePrimary={getCodeSnippet("ios.imports.swift")}
          codeSecondary={getCodeSnippet("ios.imports.objc")}
          showLineNumbers={true}
        />
      </>
    ),
    shouldDisplayNavigationButtons: true,
  },
];

export const createFlutterSteps = ({ t }: FlutterStepsParams): SendInappStep[] => [
  {
    label: t("ip_SendInApp_flutter_importAppsFlyerSDK"),
    component: (
      <DJSimpleCodeBlock
        codePrimary="import 'package:appsflyer_sdk/appsflyer_sdk.dart';"
        showLineNumbers={false}
        language="dart"
      />
    ),
    shouldDisplayNavigationButtons: true,
  },
];

export const createReactNativeSteps = ({
  t,
}: ReactNativeStepsParams): SendInappStep[] => [
  {
    label: t("ip_CreateInApp_reactnative_step1_label"),
    component: (
      <>
        <Typography>{t("ip_CreateInApp_reactnative_step1_description")}</Typography>
        <DJSimpleCodeBlock
          codePrimary='import appsFlyer from "react-native-appsflyer";'
          showLineNumbers={false}
          language="javascript"
        />
      </>
    ),
    shouldDisplayNavigationButtons: true,
  },
];
